import Vue from 'vue'
import Router from 'vue-router'

import VueForm from '@/components/Form'
import EmailVerification from '@/components/EmailVerification'
// import VueCards from '@/components/Cards'
import NotFoundError from '@/components/404'
// import SearchForm from '@/components/SearchForm'
import LiveFeed from '@/components/admin/LiveFeed'
import GeneralSearchPage from '@/components/admin/GeneralSearchPage'
import Reports from '@/components/admin/Reports'
import Layout from '@/components/admin/Layout'
import XeroSetting from '@/components/admin/XeroSetting'
import AllQuotes from '@/components/admin/AllQuotes'
// import AllUsers from '@/components/admin/AllUsers'
import Overview from '@/components/admin/Overview'
import CompanyDetailsDisplay from '@/components/admin/CompanyDetailsDisplay'
import ContractorDetailsDisplay from '@/components/admin/ContractorDetailsDisplay'
import ForgotPassword from '@/components/ForgotPassword'
import DatabaseManager from '@/components/admin/DatabaseManager'
import QuoteDetailsDisplay from '@/components/displays/QuoteDetailsDisplay'
// import DatabaseTableDisplay from '@/components/admin/DatabaseTableDisplay'
import PublicPdf from '@/components/PublicPdf'
// import Invoice1 from '@/components/admin/Invoice1'
import PricingUpload from '@/components/admin/PricingUpload'

const render = function (h) {
  return h('div', [ h('router-view') ])
}

Vue.use(Router)

export default new Router({
  linkActiveClass: 'active',
  mode: 'history',
  routes: [
    {
      path: '/api/public/pdf/:uuid',
      component: PublicPdf
    },
    {
      path: '',
      component: Layout,
      meta: {
        authType: 'admin'
      },
      children: [
        {
          path: '',
          name: 'Home',
          component: Overview
        },
        {
          path: 'login',
          component: {
            name: 'Login',
            render
          },
          meta: {
            authType: 'public'
          },
          children: [
            {
              name: 'Login',
              path: '',
              component: VueForm,
              meta: {
                authType: 'public',
                vueForm: 'adminLogin',
                vueFormMethod: 'post'
              }
            }
          ]
        },
        {
          path: 'forgot-password',
          component: ForgotPassword,
          name: 'Forgot Password?',
          meta: {
            authType: 'public'
          }
        },
        {
          path: 'reset-password/:resetToken',
          component: {
            name: 'Reset Password',
            render
          },
          meta: {
            authType: 'public'
          },
          children: [
            {
              name: 'Reset Password',
              path: '',
              component: VueForm,
              meta: {
                authType: 'public',
                vueForm: 'resetPassword',
                vueFormMethod: 'post'
              }
            }
          ]
        },
        {
          path: 'forgot-username',
          component: {
            name: 'ForgotUsername',
            render
          },
          meta: {
            authtype: 'public'
          },
          children: [
            {
              name: 'Forgot Username',
              path: '',
              component: VueForm,
              meta: {
                authType: 'public',
                vueForm: 'forgotUsername',
                vueFormMethod: 'post'
              }
            }
          ]
        },
        {
          path: 'emailVerification',
          component: {
            name: 'VerifyEmail',
            render
          },
          meta: {
            authType: 'public'
          },
          children: [
            {
              name: 'Verify Email',
              path: ':token',
              component: EmailVerification,
              meta: {
                authType: 'public'
              }
            }
          ]
        },
        {
          path: 'resendVerification',
          component: {
            name: 'resendVerification',
            render
          },
          meta: {
            authType: 'public'
          },
          children: [
            {
              path: '',
              name: 'Re-Send Verification E-mail',
              component: VueForm,
              meta: {
                authType: 'public',
                vueForm: 'resendVerif',
                vueFormMethod: 'post'
              }
            }
          ]
        },
        {
          path: 'register',
          component: {
            name: 'Register',
            render
          },
          meta: {
            authType: 'public'
          },
          children: [
            {
              path: '',
              name: 'Register',
              component: VueForm,
              meta: {
                authType: 'public',
                vueForm: 'register',
                vueFormMethod: 'post'
              }
            }
          ]
        },
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Overview,
          meta: {
            allUserTypes: true
          }
        },
        {
          path: 'newQuote',
          name: 'Create Quote',
          component: VueForm,
          meta: {
            authType: 'admin',
            client: true,
            vueForm: 'newQuote',
            vueFormMethod: 'post'
          },
          children: [
            {
              path: ':quoteUuid',
              name: 'Generate Quote',
              component: VueForm,
              meta: {
                client: true,
                authType: 'admin',
                vueForm: 'newQuote',
                vueFormMethod: 'post'
              }
            }
          ]
        },
        {
          path: 'account',
          component: VueForm,
          meta: {
            allUserTypes: true,
            authType: 'admin',
            vueForm: 'editAccount',
            vueFormMethod: 'post'
          }
        },
        {
          path: 'createQuote',
          component: {
            name: 'QuotesComponentName',
            render
          },
          children: [
            {
              path: '',
              name: 'New Quote',
              component: VueForm,
              meta: {
                authType: 'admin',
                vueForm: 'newQuoteByAdmin',
                vueFormMethod: 'post'
              }
            }
          ]
        },
        {
          path: 'clients',
          component: {
            name: 'AllUsersComponent',
            render
          },
          children: [
            {
              path: '',
              name: 'Clients',
              component: GeneralSearchPage,
              meta: {
                permalink: 'client',
                showSearch: true,
                searchHidden: true,
                tableDisplay: true,
                showPaging: true
              }
            }
          ]
        },
        {
          path: 'quotes',
          component: {
            name: 'QuotesComponentName',
            render
          },
          children: [
            {
              path: '',
              name: 'My Quotes',
              component: Reports,
              meta: {
                authType: 'admin',
                client: true,
                reportType: 'quote',
                showSearch: true
              }
            }
          ]
        },
        {
          path: 'workSummary',
          name: 'Work Summary',
          component: ContractorDetailsDisplay,
          meta: {
            contractor: true
          }
        },
        {
          path: 'liveFeed',
          name: 'Live Feed',
          component: LiveFeed,
          meta: {
            authType: 'admin',
            contractor: true
          }
        },
        {
          path: 'approvedQuotes',
          component: {
            name: 'AllQuotesComponent',
            render
          },
          children: [
            {
              path: '',
              name: 'Approved Quotes',
              component: AllQuotes,
              meta: {
                authType: 'admin',
                contractor: true,
                reportType: 'approvedQuotes',
                showSearch: true
              }
            },
            // TODO Here Cost should be uneditable since quote has been accepted and Invoice has been sent to the customer.
            {
              path: 'edit/:quoteUuid',
              name: 'Edit Quote',
              component: VueForm,
              meta: {
                authType: 'admin',
                vueForm: 'editQuote',
                vueFormMethod: 'post'
              }
            },
            {
              path: 'createReport/:quoteUuid',
              name: 'Create Report',
              component: VueForm,
              meta: {
                authType: 'admin',
                contractor: true,
                vueForm: 'createReport',
                vueFormMethod: 'post'
              }
            }
          ]
        },
        {
          path: 'manualQuotes',
          component: {
            name: 'AllQuotesComponent',
            render
          },
          children: [
            {
              path: '',
              name: 'Manual Quote Requests',
              component: AllQuotes,
              meta: {
                authType: 'admin',
                reportType: 'manualQuotes',
                showSearch: true
              }
            },
            {
              path: 'edit/:quoteUuid',
              name: 'Edit Quote for Manual Cost Check Request',
              component: VueForm,
              meta: {
                authType: 'admin',
                vueForm: 'editQuote',
                vueFormMethod: 'post'
              }
            }
          ]
        },
        {
          path: 'priceGuaranteeQuoteRequests',
          component: {
            name: 'AllQuotesComponent',
            render
          },
          children: [
            {
              path: '',
              name: 'Price Beat Guarantee Quote Requests',
              component: AllQuotes,
              meta: {
                authType: 'admin',
                reportType: 'priceGuaranteeQuoteRequests',
                showSearch: true
              }
            },
            {
              path: 'editPBGquote/:quoteUuid',
              name: 'Edit Quote for Price Beat Guarantee Request',
              component: VueForm,
              meta: {
                authType: 'admin',
                vueForm: 'editPBGquote',
                vueFormMethod: 'post'
              }
            }
          ]
        },
        // TODO Action required Quotes should use AllQuotes component because it has Responsive table. Column name will be different for approved and non-approved quotes.
        // meta.reportType: 'nonApprovedQuotes'
        // Search fields will be different for Approved and NonApproved quotes. For example, jumpedQueue.
        // {
        //   path: 'nonApprovedQuotes',
        //   component: {
        //     name: 'AllQuotesComponent',
        //     render
        //   },
        //   children: [
        //     {
        //       path: '',
        //       name: 'Non Approved Quotes',
        //       component: AllQuotes,
        //       meta: {
        //         authType: 'admin',
        //         reportType: 'nonApprovedQuotes',
        //         showSearch: true
        //       }
        //     }
        //   ]
        // },
        {
          path: 'quote/:quoteUuid',
          component: QuoteDetailsDisplay
        },
        {
          path: 'database-manager',
          component: {
            name: 'DatabaseManager',
            render
          },
          children: [
            {
              path: '',
              name: 'Database Manager',
              component: DatabaseManager,
              meta: {
                authType: 'admin'
              }
            },
            {
              path: 'generalSettings',
              name: 'General Settings',
              component: VueForm,
              meta: {
                vueForm: 'editGeneralSettings',
                vueFormMethod: 'post',
                authType: 'admin'
              }
            },
            {
              path: 'settings/:quoteTypeUuid',
              name: 'Settings',
              component: VueForm,
              meta: {
                vueForm: 'editSettings',
                vueFormMethod: 'post',
                authType: 'admin'
              }
            },
            {
              path: 'xeroSettings',
              name: 'Xero Account Settings',
              component: XeroSetting
            },
            {
              path: 'staff',
              name: 'Budget Vals Staff',
              component: GeneralSearchPage,
              meta: {
                permalink: 'staff',
                allowNewObject: true,
                showSearch: true,
                searchHidden: true,
                tableDisplay: true,
                showPaging: true
              }
            },
            {
              path: 'contractor',
              component: {
                name: 'Contractors',
                render
              },
              children: [
                {
                  path: '',
                  name: 'Budget Vals Contractors',
                  component: GeneralSearchPage,
                  meta: {
                    permalink: 'contractor',
                    allowNewObject: true,
                    showSearch: true,
                    searchHidden: true,
                    tableDisplay: true,
                    showPaging: true
                  }
                },
                {
                  path: ':AssigneeUuid',
                  component: ContractorDetailsDisplay
                }
              ]
            },
            {
              path: 'referralCode',
              component: {
                name: 'ReferralCode',
                render
              },
              children: [
                {
                  path: '',
                  name: 'Referral Codes',
                  component: GeneralSearchPage,
                  meta: {
                    permalink: 'referralCode',
                    allowNewObject: true,
                    showSearch: true,
                    searchHidden: true,
                    tableDisplay: true,
                    showPaging: true
                  }
                }
              ]
            },
            {
              path: 'my-referral-codes',
              component: {
                name: 'ReferralCode',
                render
              },
              children: [
                {
                  path: '',
                  name: 'Referral Codes',
                  component: GeneralSearchPage,
                  meta: {
                    permalink: 'referralCode',
                    allowNewObject: false,
                    showSearch: true,
                    searchHidden: true,
                    tableDisplay: true,
                    showPaging: true
                  }
                }
              ]
            },
            {
              path: 'companies',
              component: {
                name: 'Companies',
                render
              },
              children: [
                {
                  path: '',
                  name: 'Companies',
                  component: GeneralSearchPage,
                  meta: {
                    permalink: 'companies',
                    showSearch: true,
                    searchHidden: true,
                    tableDisplay: true,
                    allowNewObject: true,
                    showPaging: true
                  }
                },
                {
                  path: ':companyUuid',
                  component: CompanyDetailsDisplay,
                  meta: {
                    reload: 'loadCompany'
                  }
                }
              ]
            },
            {
              path: 'pricing',
              name: 'Import Price List',
              component: PricingUpload
            }
          ]
        },
        {
          path: 'awaitingCustomers',
          name: 'Waiting Customers',
          component: Reports,
          meta: {
            authType: 'admin',
            reportType: 'waitingCustomer',
            showSearch: true
          }
        },
        {
          path: 'invoices',
          name: 'Invoices/Payments',
          component: Reports,
          meta: {
            reportType: 'invoice',
            showSearch: true
          }
        },
        {
          path: '*',
          component: NotFoundError
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js